import React, { useEffect, useState } from 'react';
import { HdModal } from '../../../components';
import { useQuery } from '../../../core/hooks/useQuery';
import useService from '../../../injector/hooks/useService';
import { NPSService } from '../../../core/services/nps.service';
import { NPSDialogFeedbackForm } from './NPSDialogFeedbackForm';
import { NPSDialogPostSubmissionContent } from './NPSDialogPostSubmissionContent';

export interface NPSDialogProps {
  open: boolean;
  feedbackId: string;
  onClose: () => any;
}

export function NPSDialog(props: NPSDialogProps) {
  const [isFeedbackSubmitted, setIsFeedbackSubmitted] = useState(false);

  const onClose = () => {
    props.onClose();
    setIsFeedbackSubmitted(false);
  };

  return (
    <HdModal
      open={props.open}
      onClose={onClose}
      contentClassName='border-lg'
      styling={{ width: isFeedbackSubmitted ? '395px' : '485px' }}
    >
      <NPSDialogInner
        {...props}
        isFeedbackSubmitted={isFeedbackSubmitted}
        setIsFeedbackSubmitted={setIsFeedbackSubmitted}
        onClose={onClose}
      />
    </HdModal>
  );
}

export function NPSDialogInner({
  isFeedbackSubmitted,
  setIsFeedbackSubmitted,
  feedbackId,
  onClose
}: NPSDialogProps & {
  isFeedbackSubmitted: boolean;
  setIsFeedbackSubmitted: (v: boolean) => void;
}) {
  const npsService = useService(NPSService);
  const [rating, setRating] = useState(npsService.getNpsScore());

  const {
    data: scheduleCallLink,
    uiState: scheduleCallLinkFetchState,
    fetch: fetchScheduleCallLink
  } = useQuery({
    dataSource$: () => {
      return npsService.getNPSScheduleCallLink().toPromise();
    }
  });

  useEffect(() => {
    fetchScheduleCallLink();
  }, []);

  return (
    <>
      {isFeedbackSubmitted ? (
        <NPSDialogPostSubmissionContent
          rating={rating}
          scheduleCallLink={scheduleCallLink}
          scheduleCallLinkFetchState={scheduleCallLinkFetchState}
          onClose={onClose}
        />
      ) : (
        <NPSDialogFeedbackForm
          feedbackId={feedbackId}
          rating={rating}
          setRating={setRating}
          onSubmit={() => setIsFeedbackSubmitted(true)}
          onClose={onClose}
        />
      )}
    </>
  );
}
